import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import WistiaPlayer from 'modules/onboarding/components/WistiaPlayer'
import { getVideoId } from 'modules/onboarding/components/WistiaPlayer/utils'
import PopularTopics from './PopularTopics'
import Resources from './Resources'
import Tutorials from './Tutorials'

type Props = {
  open: boolean
  onClose: () => void
}

const WidgetSidepanel = ({ open, onClose }: Props) => {
  const { pathname } = useLocation()
  const {
    access: { locale },
    company,
  } = useCurrentSession()
  const [isTutorialsSectionOpen, setIsTutorialsSectionOpen] = useState(false)

  const eventPayload = {
    page_path: pathname,
    page_url: window.location.href,
    form_number_of_employees: company.numberEmployees,
    from: 'help_widget',
  }

  const onCloseSidepanel = () => {
    setIsTutorialsSectionOpen(false)
    onClose()
  }

  const getSidepanelTitle = () => {
    if (isTutorialsSectionOpen) {
      return i18n.t('help_widget.sidepanel.resources.tutorials')
    } else {
      return i18n.t('help_widget.popover.help.title')
    }
  }

  return (
    <Sidepanel
      onClose={onCloseSidepanel}
      open={open}
      closeLabel="Close"
      title={getSidepanelTitle()}
    >
      {isTutorialsSectionOpen ? (
        <Tutorials
          eventPayload={eventPayload}
          setIsTutorialsSectionOpen={setIsTutorialsSectionOpen}
        />
      ) : (
        <Box gap="s32" paddingTop="s8">
          <Resources
            eventPayload={eventPayload}
            setIsTutorialsSectionOpen={setIsTutorialsSectionOpen}
          />
          <Box gap="s16">
            <Text size="100" color="grey800" weight="bold" caps>
              {i18n.t('help_widget.sidepanel.quick_tour.title')}
            </Text>
            <Box
              onClick={() =>
                track(trackingEvents.onboarding.goToQuickTourOfFactorial, eventPayload)
              }
            >
              <WistiaPlayer videoId={getVideoId(locale)} isResponsive />
            </Box>
          </Box>
          <PopularTopics locale={locale} eventPayload={eventPayload} />
        </Box>
      )}
    </Sidepanel>
  )
}

export default WidgetSidepanel
